import { render, staticRenderFns } from "./newGood.vue?vue&type=template&id=0874d8b1&scoped=true&"
import script from "./newGood.vue?vue&type=script&lang=js&"
export * from "./newGood.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./newGood.vue?vue&type=style&index=0&id=0874d8b1&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0874d8b1",
  "4b13c042"
  
)

export default component.exports